import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ConfigurationService } from "../../../shared/services/configuration.service";
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationAPIService } from "../../../../api";
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'dynamica-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    imports: [HeaderComponent, RouterOutlet, FooterComponent]
})
export class MainLayoutComponent {
  
  private router = inject(Router);
  private configurationService = inject(ConfigurationService);
  private configApi = inject(ConfigurationAPIService);
  private oidcSecurityService = inject(OidcSecurityService);
  private translate = inject(TranslateService);

  currentLang = 'en';
  languages = ['de', 'en'];
  routeKey: string;

  constructor() {
    this.translate.addLangs( this.languages );
    this.translate.setFallbackLang( this.currentLang );
    this.translate.use( this.currentLang );

    this.oidcSecurityService.isAuthenticated$.subscribe(
      ( { isAuthenticated } ) => {
        if( isAuthenticated ) {
          this.router.events.subscribe( event => {
            if( event instanceof NavigationEnd ) {
              this.routeKey = event.url.split( '/' )[1];
            }
          } );
          this.configApi.getAppConfiguration().subscribe( res => {
            if( res ) {
              this.configurationService.configuration.next( res );
            }
          } );

        }
      }
    );
  }
}
